import { render } from "./EditImage.vue?vue&type=template&id=68de55d0"
import script from "./EditImage.vue?vue&type=script&lang=js"
export * from "./EditImage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\甘小星\\Desktop\\sakai-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__